import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartCtx = createContext(null);
const KEY = "ts_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });
  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (item) => {
    setItems((prev) => {
      const key = `${item.product_id}|${item.size}|${item.color}`;
      const found = prev.find((i) => `${i.product_id}|${i.size}|${i.color}` === key);
      if (found) return prev.map((i) => i === found ? { ...i, qty: Math.min(20, i.qty + item.qty) } : i);
      return [...prev, item];
    });
  };
  const update = (idx, qty) => setItems((prev) => prev.map((it, i) => i === idx ? { ...it, qty: Math.max(1, Math.min(20, qty)) } : it));
  const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const clear = () => setItems([]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);
  const subtotal = useMemo(() => items.reduce((s, i) => s + i.qty * i.price, 0), [items]);

  return <CartCtx.Provider value={{ items, add, update, remove, clear, count, subtotal }}>{children}</CartCtx.Provider>;
}
export const useCart = () => useContext(CartCtx);
